import React, { useEffect, useState } from 'react';
import {
  DynamicValue,
  Element,
  FormValue,
} from '@fulcrumapp/fulcrum-core';
import CheckboxField from './fields/checkbox-field';

interface Props {
  value: DynamicValue;
  onChange: (value: DynamicValue) => void;
}

const ChecklistForm = ({ value, onChange }: Props) => {
  const checklistItemValue = value.items[0] || value.createNewItem();
  const [values, setValues] = useState(checklistItemValue.values.copy());

  useEffect(() => {
    const newElementsJSON = checklistItemValue.elements.map((element: Element) => element.toJSON());
    const newValuesJSON = values.toJSON();
    const newChecklistItemValueJSON = {
      metadata: checklistItemValue.metadata,
      elements: newElementsJSON,
      values: newValuesJSON,
    };
    const newChecklistValue = new DynamicValue(value.element, [newChecklistItemValueJSON]);
    onChange(newChecklistValue);
  }, [values]);

  const handleChangeFieldValue = (newValue: FormValue) => {
    const newValues = values.copy();
    newValues.set(newValue.element.key, newValue);
    setValues(newValues);
  };

  // Eventually, we likely want to use the shared functionality in the EditorFields
  // component. However, right now look and feel is pretty different, and there are
  // only a few supported fields for checklists, so rendering fields here for now.
  const renderCheckboxField = (element: Element) => (
    <CheckboxField
      key={element.key}
      element={element}
      value={checklistItemValue.values.get(element.key)}
      // @ts-ignore
      onChange={handleChangeFieldValue}
    />
  );

  const checklistFieldRenderers = {
    CheckboxField: renderCheckboxField,
  };

  const renderChecklistField = (element: Element) => {
    if (element.type in checklistFieldRenderers) {
      return checklistFieldRenderers[element.type](element);
    }
    return <></>;
  };

  return (
    <>
      {checklistItemValue.elements.map(renderChecklistField)}
    </>
  );
};

export default ChecklistForm;
